import { NavLink, Outlet } from "@remix-run/react";

import {
  FeaturesContent as baseFeaturesText,
  getLocalizedContent,
} from "@onzeit/shared";
import { useParams } from "@remix-run/react";

import clsx from "clsx";
import { getSlug } from "~/utils/getSlug";

export default function Index() {
  const locale = useParams().locale;
  const { data } = getLocalizedContent(locale!, baseFeaturesText);

  return (
    <main className="mx-automax-w-6xl">
      <h1 className="mb-2 text-2xl font-bold xl:text-4xl">{data.heading}</h1>
      <p className="font-regular mb-4 mt-4 text-xl">{data.subheading}</p>

      <div className="mt-8 flex flex-wrap gap-2">
        {data.features!.map((group) => {
          const slug = getSlug(group.title, locale!);
          return (
            <NavLink
              key={`h_${slug}`}
              to={group.detailLink}
              className={({ isActive, isPending }) =>
                clsx(
                  "rounded-lg border-2 bg-gradient-to-bl px-4 py-2 text-indigo-500",
                  group.sectionGradient,
                  !isActive ? "font-medium" : "border-indigo-600 font-bold",
                )
              }
            >
              {group.details.title}
            </NavLink>
          );
        })}
      </div>

      <Outlet />
    </main>
  );
}
